import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Page, Header, Alert, FilesDropzone } from 'components';
import { Card, CardContent } from '@mui/material';
import { enqueueSnackbar } from 'actions';
import _ from 'underscore';

import { E2ENbrRelationsUploadRun } from '../actions/E2ENbrRelationsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const E2ENbrRelations = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const _NbrRelationsFilesUpload = files => {
		files.forEach(file => {
			if (!file.size > 10000000) {
				dispatch(
					enqueueSnackbar({
						message: `File ${file.name} not valid. Please check file size.`,
						options: { variant: 'warning' }
					})
				);
			}
		});
		dispatch(E2ENbrRelationsUploadRun(files));
	};

	return (
		<Page className={classes.root} title="Optimization">
			<Header module="Optimization" view="E2E NBR Relations" />
			<Alert
				className={classes.container}
				variant="info"
			/>
			<Card className={classes.container} container spacing={3}>
				<CardContent>
					<FilesDropzone acceptedTypes=".xlsx" upload={_NbrRelationsFilesUpload} />
				</CardContent>
			</Card>
		</Page>
	);
};

export default E2ENbrRelations;
